import * as types from './types';

const fetchArchetypeSuccess = data => ({
  type: types.GENERAL_REPORT_ARCHETYPE_FETCH_SUCCESS,
  payload: {
    columns: data.columns
  }
});

const fetchDataStart = () => ({
  type: types.GENERAL_REPORT_DATA_FETCH_START
});

const fetchDataSuccess = data => ({
  type: types.GENERAL_REPORT_DATA_FETCH_SUCCESS,
  payload: {
    data
  }
});

export default { fetchArchetypeSuccess, fetchDataStart, fetchDataSuccess };
